export default "https://cdn-static.gokick.com/assets/30adf10d1d1967cb40501bfdbefb418f6cea25a6/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";